import { render, staticRenderFns } from "./MasterDataIdle.vue?vue&type=template&id=e66a9e7c&scoped=true&"
import script from "./MasterDataIdle.vue?vue&type=script&lang=js&"
export * from "./MasterDataIdle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66a9e7c",
  null
  
)

export default component.exports